import {
  Box,
  Icon,
  Center,
  Flex,
  Grid,
  GridItem,
  Image,
  Text,
  Skeleton,
  CircularProgress,
  Button,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {
  listBookings,
  getRoomMin,
  bookingsByGuestID,
} from "../../graphql/queries";
import { API, graphqlOperation, Storage, Auth } from "aws-amplify";
import { AiFillCalendar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export const BookingTile = ({ booking, storedStripeId }) => {
  const MotionBox = motion(Box);
  const [room, setRoom] = useState({});
  const bookingStatus = JSON.parse(booking.status);

  // If room.id is missing, the tile is "loading" and we disable clicks
  const isLoaded = !!room.id;

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      // Proceed with fetching room data if the user is authenticated
      const roomDataResponse = await API.graphql(
        graphqlOperation(getRoomMin, { id: booking.roomID })
      );
      const roomData = roomDataResponse.data.getRoom;

      console.log(roomData);

      // Optionally handle image fetching logic here

      if (!roomData.pmsID && roomData.images?.length > 0) {
        roomData.images[0] = await Storage.get(roomData.images[0]).catch(
          (error) => {
            console.error("Error retrieving image:", error);
            return roomData.images[0];
          }
        );
      }

      setRoom(roomData);
    } catch (err) {
      if (err === "No current user") {
        console.error(
          "No user authenticated. Redirecting to login or showing error message."
        );
        // Handle the case where the user is not authenticated (e.g., redirect to login)
      } else {
        console.error("Error fetching room data or authenticating user:", err);
      }
    }
  };

  const inputDateIn = booking.checkInDate;
  const dateObjIn = new Date(inputDateIn);
  const optionsIn = { timeZone: "UTC", month: "short", day: "numeric" };
  const outputDateIn = dateObjIn.toLocaleDateString("en-US", optionsIn);

  const inputDateOut = booking.checkOutDate;
  const dateObjOut = new Date(inputDateOut);
  const optionsOut = { timeZone: "UTC", month: "short", day: "numeric" };
  const outputDateOut = dateObjOut.toLocaleDateString("en-US", optionsOut);

  const navigate = useNavigate();

  const handleSelect = () => {
    // Prevent clicks if not loaded
    if (!isLoaded) return;
    if (bookingStatus.done) {
      navigate("/main", { state: { room, booking } });
    } else {
      navigate("/onboarding", { state: { room, booking, storedStripeId } });
    }
  };

  // Conditionally apply pointerEvents, cursor, and onClick
  const clickableProps = {
    pointerEvents: isLoaded ? "auto" : "none",
    cursor: isLoaded ? "pointer" : "not-allowed",
    onClick: isLoaded ? handleSelect : undefined,
  };

  //6341f671-008a-4295-b5a1-d8f9a2268412
  return (
    <>
      {room.id === "53a4a418-30ce-4737-9e1a-83463e988753" ? (
        <MotionBox
          p={"5px"}
          bg={"#2D3748"}
          // bg={"#2D3748"}
          mb={3}
          borderRadius={"10px"}
          animate={{
            backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
          }}
          transition={{
            duration: 10,
            ease: "easeInOut",
            loop: Infinity,
          }}
          background="linear-gradient(270deg, #ff7ea9, #d369d0, #ff6498)"
          backgroundSize="200% 200%"
          {...clickableProps}
        >
          <Grid templateColumns="35% 65%">
            <GridItem h="81px" w="100%">
              {!room.images ? (
                <Skeleton borderRadius={"8px"} h="100%" w="100%" />
              ) : (
                <Image
                  src={room.images[0]}
                  objectFit="cover"
                  h="100%"
                  w="100%"
                  borderRadius={"8px"}
                />
              )}
            </GridItem>

            <GridItem mx={3}>
              <Flex flexDirection={"column"} h={"100%"} justifyContent="center">
                <Text mb={1}>
                  {room.address &&
                    JSON.parse(room.address)
                      .formatted_address.split(",")
                      .slice(0, -2)
                      .join(",")}
                </Text>

                <Flex alignItems={"center"}>
                  <Icon as={AiFillCalendar} mr="1" fontSize={"15px"} />

                  <Text fontWeight={800} fontSize={"12px"}>
                    {outputDateIn} - {outputDateOut}
                  </Text>
                </Flex>
              </Flex>
            </GridItem>
          </Grid>
        </MotionBox>
      ) : (
        <Box
          p={"5px"}
          bg={"#2D3748"}
          mb={3}
          borderRadius={"10px"}
          {...clickableProps}
        >
          <Grid templateColumns="35% 65%">
            <GridItem h="81px" w="100%">
              {!room.images ? (
                <Skeleton borderRadius={"8px"} h="100%" w="100%" />
              ) : (
                <Image
                  src={room.images[0]}
                  objectFit="cover"
                  h="100%"
                  w="100%"
                  borderRadius={"8px"}
                />
              )}
            </GridItem>

            <GridItem mx={3}>
              <Flex flexDirection={"column"} h={"100%"} justifyContent="center">
                <Text mb={1}>
                  {room.address &&
                    JSON.parse(room.address)
                      .formatted_address.split(",")
                      .slice(0, -2)
                      .join(",")}
                </Text>

                <Flex alignItems={"center"}>
                  <Icon as={AiFillCalendar} mr="1" fontSize={"15px"} />

                  <Text fontWeight={800} fontSize={"12px"}>
                    {outputDateIn} - {outputDateOut}
                  </Text>
                </Flex>
              </Flex>
            </GridItem>
          </Grid>
        </Box>
      )}
    </>
  );
};
